<template>
  <article>
    <v-toolbar app class="black white--text">
      <v-toolbar-side-icon @click="sideOpen = !sideOpen" class="white--text" />

      <v-toolbar-title class="headline text-uppercase">
        <router-link class="navhome white--text" to="/">Mindsight</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <span v-if="loggedInUser" class="white--text">{{ loggedInUser.org.name }}</span>

      <v-menu offset-y>
        <v-btn flat slot="activator" color="black">
          <v-avatar size="36px">
            <v-img v-if="loggedInUser" :src="loggedInUser.picture" />
          </v-avatar>
        </v-btn>

        <v-list>
          <v-list-tile color="white">
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logUserOut" color="white">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-toolbar>

    <v-navigation-drawer class="blue lighten-3" v-model="sideOpen" dark app>
      <v-list>
        <v-list-tile v-for="item in items" :key="item.title">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </article>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "toolbar",
  apollo: {
    loggedInUser: gql`query {
      loggedInUser {
        name
        nickname
        picture
        org {
          name
        }
      }
    }`
  },
  data() {
    return {
      sideOpen: false,
      items: [
        { title: "Overview", icon: "dashboard" },
        { title: "Applications", icon: "dvr" },
        { title: "Incidents", icon: "notification_important" }
      ]
    };
  },
  methods: {
    logUserOut() {
      this.$auth0.logout();
    }
  }
};
</script>

<style>
.navhome {
    text-decoration: none;
}
</style>
